import React from 'react';
import { useTranslation } from 'react-i18next';
import DynamicCrudPage from '../../../components/DynamicCrudPage';
import { usePricingProcess, useCompanies } from '../../../hooks';
import AddIcon from '@mui/icons-material/Add';

const PricingProcessPage = () => {
  const { t } = useTranslation();

  return (
    <DynamicCrudPage
      entityType="pricingProcess"
      hook={usePricingProcess}
      additionalHooks={{
        companies: useCompanies,
      }}
      addButtonTextKey="table.actions.addPricingProcess"
      addButtonIcon={<AddIcon />}
      entityTypeForDataTable="pricingProcess"
    />
  );
};

export default PricingProcessPage;
